
    import { injectNav, injectFooter } from './src/scripts/layout.js';
    import { initScrollAnimations } from './src/scripts/animations.js';
    document.addEventListener('DOMContentLoaded', () => {
      injectNav();
      injectFooter();
      initScrollAnimations();

      // Estimator Logic
      const typeSelect = document.getElementById('est-type');
      const pagesRange = document.getElementById('est-pages');
      const pagesVal = document.getElementById('est-pages-val');
      const chkSeo = document.getElementById('est-seo');
      const chkBackend = document.getElementById('est-backend');
      const chkSupport = document.getElementById('est-support');
      const resPrice = document.getElementById('res-price');
      const resTime = document.getElementById('res-time');
      const estCtaBtn = document.getElementById('est-cta-btn');

      if (typeSelect && pagesRange) {
        function calculate() {
          const selected = typeSelect.options[typeSelect.selectedIndex];
          let price = parseInt(selected.getAttribute('data-price'));
          let days = parseInt(selected.getAttribute('data-days'));

          const pages = parseInt(pagesRange.value);
          pagesVal.textContent = pages;
          
          const type = typeSelect.value;
          let perPageCost = 1500;
          let perPageDays = 1;
          
          if (type.startsWith('app')) {
            perPageCost = 3000;
            perPageDays = 2;
          } else if (type === 'logo') {
            perPageCost = 0;
            perPageDays = 0;
          }

          price += pages * perPageCost;
          days += pages * perPageDays;

          if (chkSeo.checked && type !== 'logo') {
            price += 2999;
            days += 1;
          }
          if (chkBackend.checked && type !== 'logo') {
            price += 9999;
            days += 5;
          }
          if (chkSupport.checked) {
            price += 4999;
          }

          resPrice.textContent = `₹${price.toLocaleString('en-IN')}`;
          resTime.innerHTML = `Estimated Delivery: <b>${days} Days</b>`;

          const details = `Type: ${typeSelect.value}, Pages: ${pages}, SEO: ${chkSeo.checked}, Backend: ${chkBackend.checked}, Support: ${chkSupport.checked}`;
          estCtaBtn.href = `./contact.html?est_price=₹${price.toLocaleString('en-IN')}&est_desc=${encodeURIComponent(details)}`;
        }

        typeSelect.addEventListener('change', calculate);
        pagesRange.addEventListener('input', calculate);
        chkSeo.addEventListener('change', calculate);
        chkBackend.addEventListener('change', calculate);
        chkSupport.addEventListener('change', calculate);

        calculate();
      }

      // Pricing Unlock Lead Generation
      const unlockForm = document.querySelector('.unlock-rate-form');
      const pricingPrices = document.querySelectorAll('.pricing-price');
      const lockBoxes = document.querySelectorAll('.lock-box, .lock-box-secondary');
      const pricingActionBtns = document.querySelectorAll('.pricing-action-btn');

      function revealRates() {
        pricingPrices.forEach(el => el.classList.remove('amount-blurred'));
        lockBoxes.forEach(el => el.style.display = 'none');
        pricingActionBtns.forEach(el => el.style.display = 'block');
      }

      if (localStorage.getItem('pricing_unlocked') === 'true') {
        revealRates();
      }

      if (unlockForm) {
        unlockForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const nameVal = unlockForm.querySelector('.name-input').value;
          const phoneVal = unlockForm.querySelector('.phone-input').value;
          const websiteVal = unlockForm.querySelector('.website-input') ? unlockForm.querySelector('.website-input').value : '';
          const submitBtn = unlockForm.querySelector('.btn-unlock');

          if (websiteVal) {
            // Silently fake success for spam bot
            localStorage.setItem('pricing_unlocked', 'true');
            revealRates();
            return;
          }

          submitBtn.disabled = true;
          submitBtn.textContent = 'Unlocking...';

          const formData = new FormData();
          formData.append('name', nameVal);
          formData.append('email', 'unlocked-rates@razaek.com');
          formData.append('phone', phoneVal);
          formData.append('website', websiteVal);
          formData.append('project_type', 'Rate Unlock Lead');
          formData.append('budget', 'N/A');
          formData.append('description', 'Unlocked pricing rates on services.html');

          fetch('./submit-contact.php', {
            method: 'POST',
            body: formData
          })
          .then(res => res.json())
          .then(data => {
            localStorage.setItem('pricing_unlocked', 'true');
            revealRates();
          })
          .catch(() => {
            localStorage.setItem('pricing_unlocked', 'true');
            revealRates();
          });
        });
      }

      const viewRateBtns = document.querySelectorAll('.btn-view-rate');
      viewRateBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const starterCard = document.getElementById('card-starter');
          if (starterCard) {
            starterCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const lockBox = starterCard.querySelector('.lock-box');
            if (lockBox) {
              lockBox.style.outline = '3px solid var(--g1)';
              setTimeout(() => {
                lockBox.style.outline = 'none';
              }, 1500);
            }
            const nameField = starterCard.querySelector('.name-input');
            if (nameField) {
              setTimeout(() => nameField.focus(), 800);
            }
          }
        });
      });
    });
  